export const EAS_FEE_SLICE_NAME = '@@easFee';

/** Sections of the EasFee API, used as dictionary keys in UI. */
export enum EEasFeeEntity {
	ANNUAL_FEE_TYPE = 'annualFeeType',
	MONTHLY_FEE = 'monthlyFee',
	INVOICING_FEE_TYPE = 'invoicingFeeType',
	FEE_CLASS = 'feeClass',
}
